export enum CardStyle {
  NORMAL = 'normal',
  COMPACT = 'compact',
}